import React from 'react';
import './ProgramSection.css';

const ProgramSection: React.FC = () => {
  return (
    <section className="program-section">
      <div className="program-image"></div>
      <div className="program-content">
        <h2>ПРОГРАММА ОЧНОГО ФИНАЛА</h2>
        
        <div className="program-timeline">
          <div className="timeline-item">
            <div className="timeline-marker">
              <div className="timeline-number">1</div>
              <div className="timeline-line"></div>
            </div>
            <div className="timeline-content">
              <h3>День 1</h3>
              <p>Регистрация участников. Открытие, установка.<br />
              Очный финал для всех команд.</p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-marker">
              <div className="timeline-number">2</div>
              <div className="timeline-line"></div>
            </div>
            <div className="timeline-content">
              <h3>День 2</h3>
              <p>Очный финал для всех команд.<br />
              Экскурсионная программа по г. Красноярску и его окрестностям.</p>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-marker">
              <div className="timeline-number">3</div>
            </div>
            <div className="timeline-content">
              <h3>День 3</h3>
              <p>Закрытие Хакатона, подведение итогов, награждение.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramSection; 